module.exports = __webpack_public_path__ + "static/assets/4fab81cea972ee8cb607dd3b035afa29.png";